// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-dialog .el-dialog__body {\r\n  -webkit-user-select: auto !important;\r\n     -moz-user-select: auto !important;\r\n      -ms-user-select: auto !important;\r\n          user-select: auto !important;\r\n  border-radius: 14px !important;\r\n  font-size: 20px !important;\r\n  padding: 15px;\n}\n.dialog-dialog .el-alert__title {\r\n  font-size: 20px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
